import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { matGraphqlApiSlice } from '../../apiSlice';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Char: { input: any; output: any };
  /** DateTime scalar as defined by https://scalars.graphql.org/andimarek/date-time.html but with 6 millisecond digits. */
  DafDateTime: { input: string; output: string };
  /** The `LocalDate` scalar type represents a ISO date string, represented as UTF-8 character sequences YYYY-MM-DD. The scalar follows the specification defined in RFC3339 */
  LocalDate: { input: any; output: any };
  /** The `Long` scalar type represents non-fractional signed whole 64-bit numeric values. Long can represent values between -(2^63) and 2^63 - 1. */
  Long: { input: number; output: number };
  UUID: { input: string; output: string };
};

/** The Register Import Status provides information about the status of the Register Data imports, as to what the most recent imported Register Data package is, and the corresponding most recent Event created as part of this data import package. */
export type Daf_RegisterImportStatus = {
  __typename?: 'DAF_RegisterImportStatus';
  /** Last Event ID of the imported register data package. */
  lastEventId: Scalars['Long']['output'];
  /** Last finished register import data package’s sequence number. */
  lastSequenceNumber: Scalars['Int']['output'];
  /** The date and time for when this current Register Import Status row was last updated. */
  lastUpdated: Scalars['DafDateTime']['output'];
};

export type DafBooleanOperationFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  neq?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DafBoundedCharOperationFilterInput = {
  eq?: InputMaybe<Scalars['Char']['input']>;
  in?: InputMaybe<Array<Scalars['Char']['input']>>;
};

export type DafBoundedIntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type DafBoundedLongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type DafBoundedStringOperationFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DafDateTimeOperationFilterInput = {
  eq?: InputMaybe<Scalars['DafDateTime']['input']>;
  gt?: InputMaybe<Scalars['DafDateTime']['input']>;
  gte?: InputMaybe<Scalars['DafDateTime']['input']>;
  lt?: InputMaybe<Scalars['DafDateTime']['input']>;
  lte?: InputMaybe<Scalars['DafDateTime']['input']>;
  ngt?: InputMaybe<Scalars['DafDateTime']['input']>;
  ngte?: InputMaybe<Scalars['DafDateTime']['input']>;
  nlt?: InputMaybe<Scalars['DafDateTime']['input']>;
  nlte?: InputMaybe<Scalars['DafDateTime']['input']>;
};

export type DafIntOperationFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ngt?: InputMaybe<Scalars['Int']['input']>;
  ngte?: InputMaybe<Scalars['Int']['input']>;
  nlt?: InputMaybe<Scalars['Int']['input']>;
  nlte?: InputMaybe<Scalars['Int']['input']>;
};

export type DafLocalDateOperationFilterInput = {
  eq?: InputMaybe<Scalars['LocalDate']['input']>;
  gt?: InputMaybe<Scalars['LocalDate']['input']>;
  gte?: InputMaybe<Scalars['LocalDate']['input']>;
  lt?: InputMaybe<Scalars['LocalDate']['input']>;
  lte?: InputMaybe<Scalars['LocalDate']['input']>;
  ngt?: InputMaybe<Scalars['LocalDate']['input']>;
  ngte?: InputMaybe<Scalars['LocalDate']['input']>;
  nlt?: InputMaybe<Scalars['LocalDate']['input']>;
  nlte?: InputMaybe<Scalars['LocalDate']['input']>;
};

export type DafLongOperationFilterInput = {
  eq?: InputMaybe<Scalars['Long']['input']>;
  gt?: InputMaybe<Scalars['Long']['input']>;
  gte?: InputMaybe<Scalars['Long']['input']>;
  in?: InputMaybe<Array<Scalars['Long']['input']>>;
  lt?: InputMaybe<Scalars['Long']['input']>;
  lte?: InputMaybe<Scalars['Long']['input']>;
  ngt?: InputMaybe<Scalars['Long']['input']>;
  ngte?: InputMaybe<Scalars['Long']['input']>;
  nlt?: InputMaybe<Scalars['Long']['input']>;
  nlte?: InputMaybe<Scalars['Long']['input']>;
};

export type DafStringOperationFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DafUuidOperationFilterInput = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/**
 * Grunddatamodel info:
 * name: BygningPåFremmedGrundFlade
 * dbName: BygningPaaFremmedGrundFlade
 * definition (da): <memo>#NOTES#bygningPåFremmedGrund, som kan være geometrisk registreret med fladegeometri
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Bygning på fremmed grund flade
 * transliteratedName: BygningPaaFremmedGrundFlade
 * URI: https://data.gov.dk/model/profile/mu/bygningpåfremmedgrundflade
 * EAID: EAID_A2B9B2EF_86F2_4f1d_87C0_1804A7071486
 */
export type Mat_BygningPaaFremmedGrundFlade = {
  __typename?: 'MAT_BygningPaaFremmedGrundFlade';
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/bestemtfastejendombfenummer
   * prefLabel (da): BFEnummer
   * definition (da): unikt fortløbende identifikation tildelt den specifikke bestemte fast ejendom
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: BFEnummer
   * sequenceNumber: 40
   */
  BFEnummer: Scalars['Long']['output'];
  StedbestemmelsesReference?: Maybe<Scalars['String']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_MultiSurface
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundfladegeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: geometri
   * sequenceNumber: 60
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri?: Maybe<SpatialMultiPolygonEpsg25832Type>;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * size: 5
   * dbName: opdeltIEjerlejligheder
   * sequenceNumber: 51
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundopdeltiejerlejligheder
   * prefLabel (da): opdelt i ejerlejligheder
   * definition (da): angiver, om der er tale om en hovedejendom, der er opdelt i ejerlejligheder.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  opdeltIEjerlejligheder: Scalars['Boolean']['output'];
  /**
   * Grunddatamodel info:
   * type: BygningPåFremmedGrundOprindelse
   * multiplicity: 1
   * size: 27
   * dbName: oprindelse
   * sequenceNumber: 52
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundoprindelse
   * prefLabel (da): oprindelse
   * definition (da): angiver, hvor de registrerede oplysninger om bygningen på fremmed grund stammer fra og om bygningen er stedfæstet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  oprindelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * size: 5
   * transliteratedName: paaHavet
   * dbName: paaHavet
   * sequenceNumber: 53
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundpaahavet
   * prefLabel (da): på havet
   * definition (da): angiver, om bygningen på fremmed grund er en bygning placeret på havet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paaHavet: Scalars['Boolean']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: URI
   * multiplicity: 0..1
   * dbName: rids
   * sequenceNumber: 54
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundrids
   * prefLabel (da): rids
   * definition (da): skitsering af en bygnings beliggenhed
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  rids?: Maybe<Scalars['String']['output']>;
  samletFastEjendomLokalId?: Maybe<Scalars['String']['output']>;
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_BygningPaaFremmedGrundFladeConnection = {
  __typename?: 'MAT_BygningPaaFremmedGrundFladeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_BygningPaaFremmedGrundFladeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_BygningPaaFremmedGrundFlade>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_BygningPaaFremmedGrundFladeEdge = {
  __typename?: 'MAT_BygningPaaFremmedGrundFladeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_BygningPaaFremmedGrundFlade;
};

export type Mat_BygningPaaFremmedGrundFladeFilterInput = {
  BFEnummer?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_BygningPaaFremmedGrundFladeFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  forretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  opdeltIEjerlejligheder?: InputMaybe<DafBooleanOperationFilterInput>;
  paaHavet?: InputMaybe<DafBooleanOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  samletFastEjendomLokalId?: InputMaybe<DafStringOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_BygningPaaFremmedGrundFlade_Se = {
  __typename?: 'MAT_BygningPaaFremmedGrundFlade_se';
  BygningPaaFremmedGrundFladeobj: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_BygningPaaFremmedGrundFlade_SeConnection = {
  __typename?: 'MAT_BygningPaaFremmedGrundFlade_seConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_BygningPaaFremmedGrundFlade_SeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_BygningPaaFremmedGrundFlade_Se>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_BygningPaaFremmedGrundFlade_SeEdge = {
  __typename?: 'MAT_BygningPaaFremmedGrundFlade_seEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_BygningPaaFremmedGrundFlade_Se;
};

export type Mat_BygningPaaFremmedGrundFlade_SeFilterInput = {
  BygningPaaFremmedGrundFladeobj?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_BygningPaaFremmedGrundFlade_SeFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: BygningPåFremmedGrundPunkt
 * dbName: BygningPaaFremmedGrundPunkt
 * definition (da): <memo>#NOTES#bygningPåFremmedGrund geometrisk registreret med punktgeometri
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Bygning på fremmed grund punkt
 * transliteratedName: BygningPaaFremmedGrundPunkt
 * URI: https://data.gov.dk/model/profile/mu/bygningpåfremmedgrundpunkt
 * EAID: EAID_1C0A5E2D_83CC_43d5_A7D7_C5B4FABF6109
 */
export type Mat_BygningPaaFremmedGrundPunkt = {
  __typename?: 'MAT_BygningPaaFremmedGrundPunkt';
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/bestemtfastejendombfenummer
   * prefLabel (da): BFEnummer
   * definition (da): unikt fortløbende identifikation tildelt den specifikke bestemte fast ejendom
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: BFEnummer
   * sequenceNumber: 40
   */
  BFEnummer: Scalars['Long']['output'];
  StedbestemmelsesReference?: Maybe<Scalars['String']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Point
   * multiplicity: 1
   * dbName: geometri
   * sequenceNumber: 60
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundpunktgeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialPointEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * size: 5
   * dbName: opdeltIEjerlejligheder
   * sequenceNumber: 51
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundopdeltiejerlejligheder
   * prefLabel (da): opdelt i ejerlejligheder
   * definition (da): angiver, om der er tale om en hovedejendom, der er opdelt i ejerlejligheder.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  opdeltIEjerlejligheder: Scalars['Boolean']['output'];
  /**
   * Grunddatamodel info:
   * type: BygningPåFremmedGrundOprindelse
   * multiplicity: 1
   * size: 27
   * dbName: oprindelse
   * sequenceNumber: 52
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundoprindelse
   * prefLabel (da): oprindelse
   * definition (da): angiver, hvor de registrerede oplysninger om bygningen på fremmed grund stammer fra og om bygningen er stedfæstet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  oprindelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * size: 5
   * transliteratedName: paaHavet
   * dbName: paaHavet
   * sequenceNumber: 53
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundpaahavet
   * prefLabel (da): på havet
   * definition (da): angiver, om bygningen på fremmed grund er en bygning placeret på havet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paaHavet: Scalars['Boolean']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: URI
   * multiplicity: 0..1
   * dbName: rids
   * sequenceNumber: 54
   * URI: https://data.gov.dk/model/profile/mu/bygningpaafremmedgrundrids
   * prefLabel (da): rids
   * definition (da): skitsering af en bygnings beliggenhed
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  rids?: Maybe<Scalars['String']['output']>;
  samletFastEjendomLokalId?: Maybe<Scalars['String']['output']>;
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_BygningPaaFremmedGrundPunktConnection = {
  __typename?: 'MAT_BygningPaaFremmedGrundPunktConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_BygningPaaFremmedGrundPunktEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_BygningPaaFremmedGrundPunkt>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_BygningPaaFremmedGrundPunktEdge = {
  __typename?: 'MAT_BygningPaaFremmedGrundPunktEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_BygningPaaFremmedGrundPunkt;
};

export type Mat_BygningPaaFremmedGrundPunktFilterInput = {
  BFEnummer?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_BygningPaaFremmedGrundPunktFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  forretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  opdeltIEjerlejligheder?: InputMaybe<DafBooleanOperationFilterInput>;
  paaHavet?: InputMaybe<DafBooleanOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  samletFastEjendomLokalId?: InputMaybe<DafStringOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_BygningPaaFremmedGrundPunkt_Se = {
  __typename?: 'MAT_BygningPaaFremmedGrundPunkt_se';
  BygningPaaFremmedGrundPunktobj: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_BygningPaaFremmedGrundPunkt_SeConnection = {
  __typename?: 'MAT_BygningPaaFremmedGrundPunkt_seConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_BygningPaaFremmedGrundPunkt_SeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_BygningPaaFremmedGrundPunkt_Se>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_BygningPaaFremmedGrundPunkt_SeEdge = {
  __typename?: 'MAT_BygningPaaFremmedGrundPunkt_seEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_BygningPaaFremmedGrundPunkt_Se;
};

export type Mat_BygningPaaFremmedGrundPunkt_SeFilterInput = {
  BygningPaaFremmedGrundPunktobj?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_BygningPaaFremmedGrundPunkt_SeFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Centroide
 * comment (da): <memo>#NOTES#punktet anvendes i Matriklen til dannelse af lodflader. Derudover anvendes centroiden som identifikation af jordstykket, hvis man som anvender ikke har lodfladen til rådighed, hvilket typisk er tilfældet ved CAD arbejde
 * dbName: Centroide
 * definition (da): <memo>#NOTES#repræsentativ punktgeometri for jordstykket, som er placeret inden i jordstykkets lodflade
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Centroide
 * URI: https://data.gov.dk/model/profile/mu/centroide
 * EAID: EAID_20AEBD93_4733_4d30_982E_742A35961F43
 */
export type Mat_Centroide = {
  __typename?: 'MAT_Centroide';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Point
   * multiplicity: 1
   * sequenceNumber: 51
   * dbName: geometri
   * URI: https://data.gov.dk/model/profile/mu/centroidegeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialPointEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  jordstykkeLokalId: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_CentroideConnection = {
  __typename?: 'MAT_CentroideConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_CentroideEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Centroide>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_CentroideEdge = {
  __typename?: 'MAT_CentroideEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Centroide;
};

export type Mat_CentroideFilterInput = {
  and?: InputMaybe<Array<Mat_CentroideFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  jordstykkeLokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Centroide_SekundaerForretnings = {
  __typename?: 'MAT_Centroide_sekundaerForretnings';
  Centroideobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Centroide_SekundaerForretningsConnection = {
  __typename?: 'MAT_Centroide_sekundaerForretningsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Centroide_SekundaerForretningsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Centroide_SekundaerForretnings>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Centroide_SekundaerForretningsEdge = {
  __typename?: 'MAT_Centroide_sekundaerForretningsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Centroide_SekundaerForretnings;
};

export type Mat_Centroide_SekundaerForretningsFilterInput = {
  Centroideobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Centroide_SekundaerForretningsFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Ejerlav
 * dbName: Ejerlav
 * definition (da): <memo>#NOTES#underinddeling af sogne i matrikulære distrikter
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Ejerlav
 * URI: https://data.gov.dk/model/profile/mu/ejerlav
 * EAID: EAID_D16E1BA2_F38E_4cc4_B59E_F35D4ADEE636
 */
export type Mat_Ejerlav = {
  __typename?: 'MAT_Ejerlav';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 1
   * dbName: ejerlavskode
   * sequenceNumber: 52
   * URI: https://data.gov.dk/model/profile/mu/ejerlavejerlavskode
   * prefLabel (da): ejerlavskode
   * definition (da): unik identifikation af det specifikke ejerlav
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  ejerlavskode: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * size: 100
   * dbName: ejerlavsnavn
   * sequenceNumber: 53
   * URI: https://data.gov.dk/model/profile/mu/ejerlavejerlavsnavn
   * prefLabel (da): ejerlavsnavn
   * definition (da): navnet på ejerlavet - normalt angivet ved ejerlav, sogn
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  ejerlavsnavn: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_MultiSurface
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/ejerlavgeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * sequenceNumber: 51
   * dbName: geometri
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialMultiPolygonEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: registreringFra
   * sequenceNumber: 6
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: registreringTil
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * transliteratedName: registreringsaktoer
   * dbName: registreringsaktoer
   * sequenceNumber: 7
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * sequenceNumber: 9
   * size: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadestatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 12
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forvaltningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * transliteratedName: virkningsaktoer
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forvaltningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_EjerlavConnection = {
  __typename?: 'MAT_EjerlavConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_EjerlavEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Ejerlav>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_EjerlavEdge = {
  __typename?: 'MAT_EjerlavEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Ejerlav;
};

export type Mat_EjerlavFilterInput = {
  and?: InputMaybe<Array<Mat_EjerlavFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  ejerlavskode?: InputMaybe<DafLongOperationFilterInput>;
  ejerlavsnavn?: InputMaybe<DafStringOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Ejerlejlighed
 * comment (da): <memo>#NOTES#hver Ejerlejlighed har en selvstændig identitet, således at der kan tinglyses rettigheder på hver enkelt Ejerlejlighed. En Ejerlejlighed er del af en hovedejendom, som enten er en Samlet fast ejendom eller en Bygning på fremmed grund. Ejeren af en Ejerlejlighed ejer selve lejligheden, mens hovedejendommen med jordstykke, trapper m.v. normalt ejes af alle ejerlejlighedsejere i fælles sameje, efter ejerlejlighedernes fordelingstal
 * dbName: Ejerlejlighed
 * definition (da): <memo>#NOTES#lejlighed i en beboelsesejendom hvor hver enkelt lejlighed ejes særskilt og betragtes som selvstændig fast ejendom, mens de fælles dele og faciliteter ejes i fællesskab af en ejerforening
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Ejerlejlighed
 * URI: https://data.gov.dk/model/profile/mu/ejerlejlighed
 * EAID: EAID_0FD7270E_53D6_445d_9572_2D0AF6D9A83A
 */
export type Mat_Ejerlejlighed = {
  __typename?: 'MAT_Ejerlejlighed';
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/bestemtfastejendombfenummer
   * prefLabel (da): BFEnummer
   * definition (da): unikt fortløbende identifikation tildelt den specifikke bestemte fast ejendom
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: BFEnummer
   * sequenceNumber: 40
   */
  BFEnummer: Scalars['Long']['output'];
  StedbestemmelsesGeometri?: Maybe<Scalars['String']['output']>;
  StedbestemmelsesReference?: Maybe<Scalars['String']['output']>;
  b_BygningPaaFremmedGrundFladeL?: Maybe<Scalars['String']['output']>;
  b_BygningPaaFremmedGrundPunktL?: Maybe<Scalars['String']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: URI
   * multiplicity: 0..1
   * sequenceNumber: 52
   * dbName: ejerlejlighedskort
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedejerlejlighedskort
   * prefLabel (da): ejerlejlighedskort
   * definition (da): sagsbilag hvorpå geometrien for ejerlejligheden og eventuelle ejerlejlighedslodder er illustreret
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  ejerlejlighedskort?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * sequenceNumber: 53
   * dbName: ejerlejlighedsnummer
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedejerlejlighedsnummer
   * prefLabel (da): ejerlejlighedsnummer
   * definition (da): identifikation af den enkelte ejerlejlighed der ligger i en hovedejendom
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  ejerlejlighedsnummer: Scalars['String']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 1
   * transliteratedName: fordelingstalNaevner
   * sequenceNumber: 54
   * dbName: fordelingstalNaevner
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedfordelingstalNaevner
   * prefLabel (da): fordelingstal nævner
   * definition (da): udgør sammen med fordelingstalTæller ejerlejlighedens andel af ejendomsretten af den hovedejendom som ejerlejligheden indgår i
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  fordelingstalNaevner: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 1
   * sequenceNumber: 55
   * transliteratedName: fordelingstalTaeller
   * dbName: fordelingstalTaeller
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedfordelingstalTaeller
   * prefLabel (da): fordelingstalTæller
   * definition (da): udgør sammen med fordelingstalNævner ejerlejlighedens andel af ejendomsretten af den hovedejendom som ejerlejligheden indgår i
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  fordelingstalTaeller: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * transliteratedName: iBygningPaaFremmedGrund
   * sequenceNumber: 56
   * size: 5
   * dbName: iBygningPaaFremmedGrund
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedibygningpaafremmedgrund
   * prefLabel (da): i bygning på fremmed grund
   * definition (da): angiver, om ejerlejligheden er beliggende i en bygning på fremmed grund
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  iBygningPaaFremmedGrund: Scalars['Boolean']['output'];
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Area
   * multiplicity: 1
   * sequenceNumber: 57
   * dbName: samletAreal
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedsamletareal
   * prefLabel (da): samlet areal
   * definition (da): angiver det aktuelle, samlede areal for ejerlejligheden i kvadratmeter
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  samletAreal: Scalars['Long']['output'];
  samletFastEjendomLokalId?: Maybe<Scalars['String']['output']>;
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_EjerlejlighedConnection = {
  __typename?: 'MAT_EjerlejlighedConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_EjerlejlighedEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Ejerlejlighed>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_EjerlejlighedEdge = {
  __typename?: 'MAT_EjerlejlighedEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Ejerlejlighed;
};

export type Mat_EjerlejlighedFilterInput = {
  BFEnummer?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_EjerlejlighedFilterInput>>;
  b_BygningPaaFremmedGrundFladeL?: InputMaybe<DafStringOperationFilterInput>;
  b_BygningPaaFremmedGrundPunktL?: InputMaybe<DafStringOperationFilterInput>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  ejerlejlighedsnummer?: InputMaybe<DafStringOperationFilterInput>;
  forretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
  iBygningPaaFremmedGrund?: InputMaybe<DafBooleanOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  samletAreal?: InputMaybe<DafLongOperationFilterInput>;
  samletFastEjendomLokalId?: InputMaybe<DafStringOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Ejerlejlighed_SekundaerForretn = {
  __typename?: 'MAT_Ejerlejlighed_sekundaerForretn';
  Ejerlejlighedobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Ejerlejlighed_SekundaerForretnConnection = {
  __typename?: 'MAT_Ejerlejlighed_sekundaerForretnConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Ejerlejlighed_SekundaerForretnEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Ejerlejlighed_SekundaerForretn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Ejerlejlighed_SekundaerForretnEdge = {
  __typename?: 'MAT_Ejerlejlighed_sekundaerForretnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Ejerlejlighed_SekundaerForretn;
};

export type Mat_Ejerlejlighed_SekundaerForretnFilterInput = {
  Ejerlejlighedobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Ejerlejlighed_SekundaerForretnFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Ejerlejlighedslod
 * comment (da): <memo>#NOTES#information vedr. ejerlejlighedslodder registreres i dag ikke i Tingbogen. Dvs. ved idriftsættelsestidspunktet af Matriklens Udvidelse vil der ikke findes ejerlejlighedslodder på eksisterende ejerlejligheder. Nye ejerlejligheder, der kommer ind efter idriftsættelse, vil bestå af én eller flere ejerlejlighedslodder. Formålet med at registrere ejerlejlighedslodder er primært at give mulighed for at landinspektører kan genbruge data i sager, hvor der sker forandring af <i>ejerlejligheder</i>
 * dbName: Ejerlejlighedslod
 * definition (da): <memo>#NOTES#en ejerlejlighed kan bestå af flere arealer, som er fysisk adskilt fra hinanden. Disse arealer kaldes ejerlejlighedslodder
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Ejerlejlighedslod
 * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedslod
 * EAID: EAID_AE0F4880_729C_4cf7_A58E_F7CCAD504065
 */
export type Mat_Ejerlejlighedslod = {
  __typename?: 'MAT_Ejerlejlighedslod';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  ejerlejlighedLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedslodetagebetegnelse
   * prefLabel (da): etagebetegnelse
   * definition (da): angivelse af hvilken etage ejerlejlighedslodden er beliggende på.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: etagebetegnelse
   * sequenceNumber: 51
   */
  etagebetegnelse: Scalars['String']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Surface
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedslodgeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: geometri
   * sequenceNumber: 52
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri?: Maybe<SpatialPolygonEpsg25832Type>;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Area
   * multiplicity: 1
   * dbName: lodAreal
   * sequenceNumber: 53
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedslodlodareal
   * prefLabel (da): lod areal
   * definition (da): det registrerede areal for det pågældende ejerlejlighedslod
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  lodAreal: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * dbName: lodBeliggenhedstekst
   * sequenceNumber: 54
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedslodlodbeliggenhedstekst
   * prefLabel (da): lod beliggenhedstekst
   * definition (da): tekst, der angiver ejerlejlighedsloddens beliggenhed i relation til hovedejendommen.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  lodBeliggenhedstekst?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * sequenceNumber: 55
   * dbName: lodLitra
   * URI: https://data.gov.dk/model/profile/mu/ejerlejlighedslodlodlitra
   * prefLabel (da): lod litra
   * definition (da): bogstav, der bruges for at angive en underinddeling af en ejerlejlighed i ejerlejlighedslodder
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  lodLitra?: Maybe<Scalars['String']['output']>;
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_EjerlejlighedslodConnection = {
  __typename?: 'MAT_EjerlejlighedslodConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_EjerlejlighedslodEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Ejerlejlighedslod>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_EjerlejlighedslodEdge = {
  __typename?: 'MAT_EjerlejlighedslodEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Ejerlejlighedslod;
};

export type Mat_EjerlejlighedslodFilterInput = {
  and?: InputMaybe<Array<Mat_EjerlejlighedslodFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  ejerlejlighedLokalId?: InputMaybe<DafStringOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  lodAreal?: InputMaybe<DafLongOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Ejerlejlighedslod_SekundaerFor = {
  __typename?: 'MAT_Ejerlejlighedslod_sekundaerFor';
  Ejerlejlighedslodobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Ejerlejlighedslod_SekundaerForConnection = {
  __typename?: 'MAT_Ejerlejlighedslod_sekundaerForConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Ejerlejlighedslod_SekundaerForEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Ejerlejlighedslod_SekundaerFor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Ejerlejlighedslod_SekundaerForEdge = {
  __typename?: 'MAT_Ejerlejlighedslod_sekundaerForEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Ejerlejlighedslod_SekundaerFor;
};

export type Mat_Ejerlejlighedslod_SekundaerForFilterInput = {
  Ejerlejlighedslodobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Ejerlejlighedslod_SekundaerForFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

export type Mat_Events = {
  __typename?: 'MAT_Events';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  entityname: Scalars['String']['output'];
  eventaction: Scalars['Char']['output'];
  eventid: Scalars['Long']['output'];
  fromfailedimport: Scalars['Boolean']['output'];
  object_datafordelerRowId: Scalars['UUID']['output'];
  object_datafordelerRowVersion: Scalars['Int']['output'];
  object_id?: Maybe<Scalars['String']['output']>;
  object_registreringfra?: Maybe<Scalars['DafDateTime']['output']>;
  object_registreringtil?: Maybe<Scalars['DafDateTime']['output']>;
  object_status?: Maybe<Scalars['String']['output']>;
  object_virkningfra?: Maybe<Scalars['DafDateTime']['output']>;
  object_virkningtil?: Maybe<Scalars['DafDateTime']['output']>;
};

/** A connection to a list of items. */
export type Mat_EventsConnection = {
  __typename?: 'MAT_EventsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_EventsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Events>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_EventsEdge = {
  __typename?: 'MAT_EventsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Events;
};

export type Mat_EventsFilterInput = {
  and?: InputMaybe<Array<Mat_EventsFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafBoundedIntOperationFilterInput>;
  entityname?: InputMaybe<DafBoundedStringOperationFilterInput>;
  eventaction?: InputMaybe<DafBoundedCharOperationFilterInput>;
  eventid?: InputMaybe<DafBoundedLongOperationFilterInput>;
  object_id?: InputMaybe<DafBoundedStringOperationFilterInput>;
  object_status?: InputMaybe<DafBoundedStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Jordstykke
 * comment (da): <memo>#NOTES#jordstykker kan selvstændigt eller i forening danne en Samlet fast ejendom. Et jordstykke kan enten være: et matrikuleret areal eller et umatrikuleret areal i form af udskilt, offentlig vej optaget i matriklen med matrikelnummer 7000 plus vejlitra.
 * dbName: Jordstykke
 * definition (da): <memo>#NOTES#areal på jordoverfladen som er afgrænset af matrikelskel
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Jordstykke
 * URI: https://data.gov.dk/model/profile/mu/jordstykke
 * EAID: EAID_8B60BEE8_D3BD_4c07_88FF_A2547A3D82D1
 */
export type Mat_Jordstykke = {
  __typename?: 'MAT_Jordstykke';
  /**
   * Grunddatamodel info:
   * type: Arealberegningsmetode
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/jordstykkearealberegningsmetode
   * prefLabel (da): arealberegningsmetode
   * definition (da): angivelse af beregningsmetoden for arealet på det pågældende jordstykke
   * size: 57
   * dbName: arealberegningsmetode
   * sequenceNumber: 51
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  arealberegningsmetode: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * dbName: arealbetegnelse
   * sequenceNumber: 52
   * URI: https://data.gov.dk/model/profile/mu/jordstykkearealbetegnelse
   * prefLabel (da): arealbetegnelse
   * definition (da): tekstlig beskrivelse af arealets art eller type
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  arealbetegnelse?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Arealtype
   * multiplicity: 0..1
   * sequenceNumber: 53
   * size: 18
   * dbName: arealtype
   * URI: https://data.gov.dk/model/profile/mu/jordstykkearealtype
   * prefLabel (da): arealtype
   * definition (da): den registrerede type for arealet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  arealtype?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 0..1
   * dbName: brugsretsareal
   * sequenceNumber: 54
   * size: 5
   * URI: https://data.gov.dk/model/profile/mu/jordstykkebrugsretsareal
   * prefLabel (da): brugsretsareal
   * definition (da): et areal, der er stiftet en brugsret over for højest 30 år, såfremt arealet udgør en del af en samlet fast ejendom, eller for højest 10 år, såfremt arealet udgør en del af en umatrikuleret ejendom
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  brugsretsareal?: Maybe<Scalars['Boolean']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * dbName: delnummer
   * sequenceNumber: 55
   * URI: https://data.gov.dk/model/profile/mu/jordstykkedelnummer
   * prefLabel (da): delnummer
   * definition (da): midlertidigt nummer tildelt jordstykket inden det får tildelt det endelige matrikelnummer
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  delnummer?: Maybe<Scalars['String']['output']>;
  ejerlavLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * dbName: faelleslod
   * sequenceNumber: 56
   * size: 5
   * URI: https://data.gov.dk/model/profile/mu/jordstykkefaelleslod
   * prefLabel (da): faelleslod
   * definition (da): angiver om jordstykket er et fælleslod og dermed indgår i flere faste ejendomme
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  faelleslod: Scalars['Boolean']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  fredskov_areal?: Maybe<Scalars['Long']['output']>;
  fredskov_omfang?: Maybe<Scalars['String']['output']>;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  jordrente_omfang?: Maybe<Scalars['String']['output']>;
  klitfredning_areal?: Maybe<Scalars['Long']['output']>;
  klitfredning_omfang?: Maybe<Scalars['String']['output']>;
  kommuneLokalId: Scalars['String']['output'];
  majoratsskov_nummer?: Maybe<Scalars['Long']['output']>;
  majoratsskov_omfang?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * sequenceNumber: 57
   * dbName: matrikelnummer
   * URI: https://data.gov.dk/model/profile/mu/jordstykkematrikelnummer
   * prefLabel (da): matrikelnummer
   * definition (da): entydig identifikation af et jordstykke inden for et ejerlav
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  matrikelnummer?: Maybe<Scalars['String']['output']>;
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  regionLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Area
   * multiplicity: 1
   * sequenceNumber: 58
   * dbName: registreretAreal
   * URI: https://data.gov.dk/model/profile/mu/jordstykkeregistreretAreal
   * prefLabel (da): registreret areal
   * definition (da): jordstykkets registrerede areal i Matriklen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreretAreal: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  samletFastEjendomLokalId: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  skelforretningssagsLokalId?: Maybe<Scalars['String']['output']>;
  sognLokalId: Scalars['String']['output'];
  stammerFraJordstykkeLokalId?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  strandbeskyttelse_areal?: Maybe<Scalars['Long']['output']>;
  strandbeskyttelse_omfang?: Maybe<Scalars['String']['output']>;
  supplerendeMaalingSagLokalId?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Vandarealinkludering
   * multiplicity: 1
   * size: 9
   * dbName: vandarealinkludering
   * sequenceNumber: 59
   * URI: https://data.gov.dk/model/profile/mu/jordstykkevandarealinkludering
   * prefLabel (da): vandarealinkludering
   * definition (da): angivelse af om et eventuelt vandareal indenfor jordstykket indgår i det registrerede areal for jordstykket.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  vandarealinkludering: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Area
   * multiplicity: 0..1
   * dbName: vejareal
   * sequenceNumber: 60
   * URI: https://data.gov.dk/model/profile/mu/jordstykkevejareal
   * prefLabel (da): vejareal
   * definition (da): det i matriklen registrerede areal for en ikke udskilt vej på jordstykket
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  vejareal?: Maybe<Scalars['Long']['output']>;
  /**
   * Grunddatamodel info:
   * type: Vejarealberegningsstatus
   * multiplicity: 1
   * size: 20
   * dbName: vejarealberegningsstatus
   * sequenceNumber: 61
   * URI: https://data.gov.dk/model/profile/mu/jordstykkevejarealberegningsstatus
   * prefLabel (da): vejarealberegningsstatus
   * definition (da): angiver hvorvidt et eventuelt vejareal på jordstykket er beregnet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  vejarealberegningsstatus: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_JordstykkeConnection = {
  __typename?: 'MAT_JordstykkeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_JordstykkeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Jordstykke>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_JordstykkeEdge = {
  __typename?: 'MAT_JordstykkeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Jordstykke;
};

export type Mat_JordstykkeFilterInput = {
  and?: InputMaybe<Array<Mat_JordstykkeFilterInput>>;
  arealberegningsmetode?: InputMaybe<DafStringOperationFilterInput>;
  arealbetegnelse?: InputMaybe<DafStringOperationFilterInput>;
  arealtype?: InputMaybe<DafStringOperationFilterInput>;
  brugsretsareal?: InputMaybe<DafBooleanOperationFilterInput>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  delnummer?: InputMaybe<DafStringOperationFilterInput>;
  ejerlavLokalId?: InputMaybe<DafStringOperationFilterInput>;
  faelleslod?: InputMaybe<DafBooleanOperationFilterInput>;
  forretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
  fredskov_areal?: InputMaybe<DafLongOperationFilterInput>;
  fredskov_omfang?: InputMaybe<DafStringOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  jordrente_omfang?: InputMaybe<DafStringOperationFilterInput>;
  klitfredning_areal?: InputMaybe<DafLongOperationFilterInput>;
  klitfredning_omfang?: InputMaybe<DafStringOperationFilterInput>;
  kommuneLokalId?: InputMaybe<DafStringOperationFilterInput>;
  majoratsskov_nummer?: InputMaybe<DafLongOperationFilterInput>;
  majoratsskov_omfang?: InputMaybe<DafStringOperationFilterInput>;
  matrikelnummer?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  regionLokalId?: InputMaybe<DafStringOperationFilterInput>;
  registreretAreal?: InputMaybe<DafLongOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  samletFastEjendomLokalId?: InputMaybe<DafStringOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  skelforretningssagsLokalId?: InputMaybe<DafStringOperationFilterInput>;
  sognLokalId?: InputMaybe<DafStringOperationFilterInput>;
  stammerFraJordstykkeLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  strandbeskyttelse_areal?: InputMaybe<DafLongOperationFilterInput>;
  strandbeskyttelse_omfang?: InputMaybe<DafStringOperationFilterInput>;
  supplerendeMaalingSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  vejareal?: InputMaybe<DafLongOperationFilterInput>;
  vejarealberegningsstatus?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: JordstykkeTemaflade
 * dbName: JordstykkeTemaflade
 * definition (da): <memo>#NOTES#en flade, der er dannet ved aggregering af temalinjer
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Jordstykke temaflade
 * URI: https://data.gov.dk/model/profile/mu/jordstykketemaflade
 * EAID: EAID_B8EC966B_3EA9_499b_841C_F3E24EDDB9EC
 */
export type Mat_JordstykkeTemaflade = {
  __typename?: 'MAT_JordstykkeTemaflade';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_MultiSurface
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/jordstykketemafladegeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * sequenceNumber: 51
   * dbName: geometri
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialMultiPolygonEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  jordstykkeLokalId: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 1
   * sequenceNumber: 52
   * dbName: temaFladeID
   * URI: https://data.gov.dk/model/profile/mu/jordstykketemafladetemafladeid
   * prefLabel (da): temaFladeID
   * definition (da): unik identifikation af temafladen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  temaFladeID: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: Tematype
   * multiplicity: 1
   * size: 17
   * sequenceNumber: 53
   * dbName: tematype
   * URI: https://data.gov.dk/model/profile/mu/jordstykketemafladetematype
   * prefLabel (da): tematype
   * definition (da): typen af tema der er registreret på det pågældende jordstykke
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  tematype: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_JordstykkeTemafladeConnection = {
  __typename?: 'MAT_JordstykkeTemafladeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_JordstykkeTemafladeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_JordstykkeTemaflade>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_JordstykkeTemafladeEdge = {
  __typename?: 'MAT_JordstykkeTemafladeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_JordstykkeTemaflade;
};

export type Mat_JordstykkeTemafladeFilterInput = {
  and?: InputMaybe<Array<Mat_JordstykkeTemafladeFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  jordstykkeLokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  temaFladeID?: InputMaybe<DafLongOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_JordstykkeTemaflade_SekundaerF = {
  __typename?: 'MAT_JordstykkeTemaflade_sekundaerF';
  JordstykkeTemafladeobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_JordstykkeTemaflade_SekundaerFConnection = {
  __typename?: 'MAT_JordstykkeTemaflade_sekundaerFConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_JordstykkeTemaflade_SekundaerFEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_JordstykkeTemaflade_SekundaerF>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_JordstykkeTemaflade_SekundaerFEdge = {
  __typename?: 'MAT_JordstykkeTemaflade_sekundaerFEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_JordstykkeTemaflade_SekundaerF;
};

export type Mat_JordstykkeTemaflade_SekundaerFFilterInput = {
  JordstykkeTemafladeobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_JordstykkeTemaflade_SekundaerFFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Jordstykke_SekundaerForretning = {
  __typename?: 'MAT_Jordstykke_sekundaerForretning';
  Jordstykkeobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Jordstykke_SekundaerForretningConnection = {
  __typename?: 'MAT_Jordstykke_sekundaerForretningConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Jordstykke_SekundaerForretningEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Jordstykke_SekundaerForretning>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Jordstykke_SekundaerForretningEdge = {
  __typename?: 'MAT_Jordstykke_sekundaerForretningEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Jordstykke_SekundaerForretning;
};

export type Mat_Jordstykke_SekundaerForretningFilterInput = {
  Jordstykkeobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Jordstykke_SekundaerForretningFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Stormfald
 * dbName: Stormfald
 * definition (da): <memo>#NOTES#registrering af udbetalt tilskud til oprydning eller gentilplantning af private fredskove, der er væltet som følge af storme.
 * historikmodel: bitemporalitet
 * prefLabel (da): Stormfald
 * URI: https://data.gov.dk/model/profile/mu/stormfald
 * EAID: EAID_5A41FCE2_7F8D_4856_B99D_0B0FD2419CDB
 */
export type Mat_Jordstykke_Stormfald = {
  __typename?: 'MAT_Jordstykke_stormfald';
  Jordstykkeobjectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: SNSJournalNummer
   * URI: https://data.gov.dk/model/profile/mu/stormfaldsnsjournalnummer
   * prefLabel (da): SNSJournalNummer
   * definition (da): det af Naturstyrelsen angivne journalnummer på en stormfaldssag
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  SNSJournalNummer: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Date
   * multiplicity: 1
   * dbName: betalingsdato
   * URI: https://data.gov.dk/model/profile/mu/stormfaldbetalingsdato
   * prefLabel (da): betalingsdato
   * definition (da): tidspunkt hvor udbetaling af stormfaldstilskud er startet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  betalingsdato: Scalars['LocalDate']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: Omfang
   * multiplicity: 1
   * size: 6
   * dbName: omfang
   * URI: https://data.gov.dk/model/profile/mu/stormfaldomfang
   * prefLabel (da): omfang
   * definition (da): angiver hvor stor en del af jordstykket der er omfattet af registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  omfang: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Date
   * multiplicity: 1
   * transliteratedName: ophoersdato
   * dbName: ophoersdato
   * URI: https://data.gov.dk/model/profile/mu/stormfaldophoersdato
   * prefLabel (da): ophørsdato
   * definition (da): tidspunkt hvor udbetaling af stormfaldstilskud er ophørt
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  ophoersdato: Scalars['LocalDate']['output'];
  /**
   * Grunddatamodel info:
   * type: Tilskudstype
   * multiplicity: 1
   * size: 30
   * dbName: tilskudstype
   * URI: https://data.gov.dk/model/profile/mu/stormfaldtilskudstype
   * prefLabel (da): tilskudstype
   * definition (da): typen af tilskud det registrerede stormfald er omfattet af
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  tilskudstype: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Jordstykke_StormfaldConnection = {
  __typename?: 'MAT_Jordstykke_stormfaldConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Jordstykke_StormfaldEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Jordstykke_Stormfald>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Jordstykke_StormfaldEdge = {
  __typename?: 'MAT_Jordstykke_stormfaldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Jordstykke_Stormfald;
};

export type Mat_Jordstykke_StormfaldFilterInput = {
  Jordstykkeobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Jordstykke_StormfaldFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Lodflade
 * comment (da): <memo>#NOTES#bemærk at Lodflade er et MatrikulærtElement i sig selv. Dvs. Lodflade og Jordstykke kan ændres uafhængigt af hinanden
 * dbName: Lodflade
 * definition (da): <memo>#NOTES#repræsentativ fladegeometri for jordstykket, som dannes ud fra de omkringliggende matrikelskel
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Lodflade
 * URI: https://data.gov.dk/model/profile/mu/lodflade
 * EAID: EAID_7C2C3988_3D69_446c_B5EB_B1979990AAC4
 */
export type Mat_Lodflade = {
  __typename?: 'MAT_Lodflade';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Surface
   * multiplicity: 1
   * dbName: geometri
   * sequenceNumber: 51
   * URI: https://data.gov.dk/model/profile/mu/lodfladegeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialPolygonEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  jordstykkeLokalId: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_LodfladeConnection = {
  __typename?: 'MAT_LodfladeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_LodfladeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Lodflade>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_LodfladeEdge = {
  __typename?: 'MAT_LodfladeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Lodflade;
};

export type Mat_LodfladeFilterInput = {
  and?: InputMaybe<Array<Mat_LodfladeFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  jordstykkeLokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Lodflade_SekundaerForretningsh = {
  __typename?: 'MAT_Lodflade_sekundaerForretningsh';
  Lodfladeobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Lodflade_SekundaerForretningshConnection = {
  __typename?: 'MAT_Lodflade_sekundaerForretningshConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Lodflade_SekundaerForretningshEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Lodflade_SekundaerForretningsh>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Lodflade_SekundaerForretningshEdge = {
  __typename?: 'MAT_Lodflade_sekundaerForretningshEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Lodflade_SekundaerForretningsh;
};

export type Mat_Lodflade_SekundaerForretningshFilterInput = {
  Lodfladeobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Lodflade_SekundaerForretningshFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: MatrikelKommune
 * dbName: MatrikelKommune
 * definition (da): <memo>#NOTES#geometrisk inddeling af kommune pba. registreringer i matrikelregisteret
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Matrikel kommune
 * URI: https://data.gov.dk/model/profile/mu/matrikelkommune
 * EAID: EAID_D18B68C2_8EC9_449c_BE43_AB8FC7530417
 */
export type Mat_MatrikelKommune = {
  __typename?: 'MAT_MatrikelKommune';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_MultiSurface
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikelkommunegeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: geometri
   * sequenceNumber: 51
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialMultiPolygonEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikelkommunekommunekode
   * prefLabel (da): kommunekode
   * definition (da): den 4-cifrede CPR-kode tilhørende kommunen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: kommunekode
   * sequenceNumber: 53
   * size: 4
   */
  kommunekode: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikelkommunekommunenavn
   * prefLabel (da): kommunenavn
   * definition (da): navnet tilhørende kommunen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * size: 100
   * dbName: kommunenavn
   * sequenceNumber: 52
   */
  kommunenavn: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: registreringFra
   * sequenceNumber: 6
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: registreringTil
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * transliteratedName: registreringsaktoer
   * dbName: registreringsaktoer
   * sequenceNumber: 7
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * sequenceNumber: 9
   * size: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadestatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 12
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forvaltningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * transliteratedName: virkningsaktoer
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forvaltningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_MatrikelKommuneConnection = {
  __typename?: 'MAT_MatrikelKommuneConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_MatrikelKommuneEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_MatrikelKommune>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_MatrikelKommuneEdge = {
  __typename?: 'MAT_MatrikelKommuneEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_MatrikelKommune;
};

export type Mat_MatrikelKommuneFilterInput = {
  and?: InputMaybe<Array<Mat_MatrikelKommuneFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  kommunekode?: InputMaybe<DafStringOperationFilterInput>;
  kommunenavn?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: MatrikelRegion
 * dbName: MatrikelRegion
 * definition (da): <memo>#NOTES#geometrisk inddeling af region pba. registreringer i Matriklen
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Matrikel region
 * URI: https://data.gov.dk/model/profile/mu/matrikelregion
 * EAID: EAID_4A61194E_84F8_4b73_BE48_9CE51D86C7AB
 */
export type Mat_MatrikelRegion = {
  __typename?: 'MAT_MatrikelRegion';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikelregionregionskode
   * size: 4
   * dbName: regionskode
   * sequenceNumber: 51
   * prefLabel (da): regionskode
   * definition (da): koden tilhørende regionen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  regionskode: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: regionsnavn
   * sequenceNumber: 52
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikelregionregionsnavn
   * prefLabel (da): regionsnavn
   * definition (da): navnet tilhørende regionen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  regionsnavn: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: registreringFra
   * sequenceNumber: 6
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: registreringTil
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * transliteratedName: registreringsaktoer
   * dbName: registreringsaktoer
   * sequenceNumber: 7
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * sequenceNumber: 9
   * size: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadestatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 12
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forvaltningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * transliteratedName: virkningsaktoer
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forvaltningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_MatrikelRegionConnection = {
  __typename?: 'MAT_MatrikelRegionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_MatrikelRegionEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_MatrikelRegion>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_MatrikelRegionEdge = {
  __typename?: 'MAT_MatrikelRegionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_MatrikelRegion;
};

export type Mat_MatrikelRegionFilterInput = {
  and?: InputMaybe<Array<Mat_MatrikelRegionFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: MatrikelSogn
 * dbName: MatrikelSogn
 * definition (da): <memo>#NOTES#geometrisk inddeling af sogn pba. registreringer i matrikelregisteret
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Matrikel sogn
 * URI: https://data.gov.dk/model/profile/mu/matrikelsogn
 * EAID: EAID_FF5DDBDB_9330_41cb_B0E5_F0B7B0DC390E
 */
export type Mat_MatrikelSogn = {
  __typename?: 'MAT_MatrikelSogn';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_MultiSurface
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikelsogngeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: geometri
   * sequenceNumber: 51
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialMultiPolygonEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: registreringFra
   * sequenceNumber: 6
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: registreringTil
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraaderegistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * transliteratedName: registreringsaktoer
   * dbName: registreringsaktoer
   * sequenceNumber: 7
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikelsognsognekode
   * prefLabel (da): sognekode
   * definition (da): den 4-cifrede CPR-kode tilhørende sognet
   * dbName: sognekode
   * sequenceNumber: 53
   * size: 4
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sognekode: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikelsognsognenavn
   * prefLabel (da): sognenavn
   * definition (da): navnet tilhørende sognet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: sognenavn
   * sequenceNumber: 52
   * size: 100
   */
  sognenavn: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * sequenceNumber: 9
   * size: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadestatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 12
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forvaltningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * transliteratedName: virkningsaktoer
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikeladministrativtomraadevirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forvaltningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_MatrikelSognConnection = {
  __typename?: 'MAT_MatrikelSognConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_MatrikelSognEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_MatrikelSogn>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_MatrikelSognEdge = {
  __typename?: 'MAT_MatrikelSognEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_MatrikelSogn;
};

export type Mat_MatrikelSognFilterInput = {
  and?: InputMaybe<Array<Mat_MatrikelSognFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  sognekode?: InputMaybe<DafStringOperationFilterInput>;
  sognenavn?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Matrikelskel
 * comment (da): <memo>#NOTES#et matrikelskel er typisk en linje, men hvis skellet følger en cirkelbue, vil cirkelbuen blive repræsenteret ved en polylinje
 * dbName: Matrikelskel
 * definition (da): <memo>#NOTES#en linje eller en polylinje (cirkelbue), der – sammen med mindst ét andet matrikelskel - afgrænser et jordstykke
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Matrikelskel
 * URI: https://data.gov.dk/model/profile/mu/matrikelskel
 * EAID: EAID_766A020A_E8DD_409e_BE5D_9B221F3D798F
 */
export type Mat_Matrikelskel = {
  __typename?: 'MAT_Matrikelskel';
  /**
   * Grunddatamodel info:
   * type: Grænsekode
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/matrikelskeladministrativgraensekode
   * prefLabel (da): administrativ grænseKode
   * size: 33
   * dbName: administrativGraenseKode
   * transliteratedName: administrativGraenseKode
   * sequenceNumber: 51
   * definition (da): angivelse af hvilke administrative inddelinger, der er sammenfaldende med skellet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  administrativGraenseKode: Scalars['String']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Curve
   * multiplicity: 1
   * dbName: geometri
   * sequenceNumber: 52
   * URI: https://data.gov.dk/model/profile/mu/matrikelskelgeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialLineStringEpsg25832Type;
  hoejreJordstykkeLokalId?: Maybe<Scalars['String']['output']>;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * sequenceNumber: 53
   * dbName: oprindelseJournalnummer
   * URI: https://data.gov.dk/model/profile/mu/matrikelskeloprindelsejournalnummer
   * prefLabel (da): oprindelseJournalnummer
   * definition (da): identifikation af den sag, via journalnummer, som indeholder de måloplysninger der er brugt til at angive objektets placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  oprindelseJournalnummer?: Maybe<Scalars['String']['output']>;
  oprindelsessagsLokalId?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Produktionsmetode
   * multiplicity: 1
   * sequenceNumber: 54
   * size: 78
   * dbName: produktionsmetode
   * URI: https://data.gov.dk/model/profile/mu/matrikelskelproduktionsmetode
   * prefLabel (da): produktionsmetode
   * definition (da): angivelse af hvilken metode og baggrundsmateriale, som matrikelskellet er produceret ved hjælp af
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  produktionsmetode: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  skelforretningssagsLokalId?: Maybe<Scalars['String']['output']>;
  skelpunkt_1LokalId: Scalars['String']['output'];
  skelpunkt_2LokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Skeltype
   * multiplicity: 1
   * size: 11
   * dbName: skeltype
   * sequenceNumber: 55
   * URI: https://data.gov.dk/model/profile/mu/matrikelskelskeltype
   * prefLabel (da): skeltype
   * definition (da): klassifikation af skellet ud fra skelhierarki
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  skeltype: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 0..1
   * dbName: transformationsId
   * sequenceNumber: 56
   * URI: https://data.gov.dk/model/profile/mu/matrikelskeltransformationsid
   * prefLabel (da): transformationsId
   * definition (da): transformationsID er en fortløbende nummerering af transformationerne inden for det enkelte ejerlav
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  transformationsId?: Maybe<Scalars['Long']['output']>;
  venstreJordstykkeLokalId?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_MatrikelskelConnection = {
  __typename?: 'MAT_MatrikelskelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_MatrikelskelEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Matrikelskel>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_MatrikelskelEdge = {
  __typename?: 'MAT_MatrikelskelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Matrikelskel;
};

export type Mat_MatrikelskelFilterInput = {
  and?: InputMaybe<Array<Mat_MatrikelskelFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  hoejreJordstykkeLokalId?: InputMaybe<DafStringOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  oprindelseJournalnummer?: InputMaybe<DafStringOperationFilterInput>;
  oprindelsessagsLokalId?: InputMaybe<DafStringOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  skelforretningssagsLokalId?: InputMaybe<DafStringOperationFilterInput>;
  skelpunkt_1LokalId?: InputMaybe<DafStringOperationFilterInput>;
  skelpunkt_2LokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  venstreJordstykkeLokalId?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Matrikelskel_SekundaerForretni = {
  __typename?: 'MAT_Matrikelskel_sekundaerForretni';
  Matrikelskelobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Matrikelskel_SekundaerForretniConnection = {
  __typename?: 'MAT_Matrikelskel_sekundaerForretniConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Matrikelskel_SekundaerForretniEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Matrikelskel_SekundaerForretni>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Matrikelskel_SekundaerForretniEdge = {
  __typename?: 'MAT_Matrikelskel_sekundaerForretniEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Matrikelskel_SekundaerForretni;
};

export type Mat_Matrikelskel_SekundaerForretniFilterInput = {
  Matrikelskelobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Matrikelskel_SekundaerForretniFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: MatrikulærSag
 * dbName: MatrikulaerSag
 * definition (da): <memo>#NOTES#helheden af de faktorer og omstændigheder der knytter sig til en matrikulær sag
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Matrikulærsag
 * transliteratedName: MatrikulaerSag
 * URI: https://data.gov.dk/model/profile/mu/matrikulaersag
 * EAID: EAID_D999DCC5_B933_4e45_86E0_FE9CB2B28FBC
 */
export type Mat_MatrikulaerSag = {
  __typename?: 'MAT_MatrikulaerSag';
  StedbestemmelsesGeometri?: Maybe<Scalars['String']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  ejerlavLokalId?: Maybe<Scalars['String']['output']>;
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærSagForretningshændelse
   * multiplicity: 1
   * sequenceNumber: 7
   * dbName: forretningshaendelse
   * size: 62
   * transliteratedName: forretningshaendelse
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * transliteratedName: forretningsomraade
   * sequenceNumber: 8
   * dbName: forretningsomraade
   * size: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 9
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_MultiSurface
   * multiplicity: 0..1
   * dbName: geometri
   * sequenceNumber: 22
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersaggeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri?: Maybe<SpatialMultiPolygonEpsg25832Type>;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  jordstykkeLokalId?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Date
   * multiplicity: 0..1
   * dbName: journaliseringsdato
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagjournaliseringsdato
   * prefLabel (da): journaliseringsdato
   * definition (da): dato for den dag, hvor sagen er journaliseret af matrikelmyndigheden.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  journaliseringsdato?: Maybe<Scalars['LocalDate']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * dbName: kommune
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagkommune
   * prefLabel (da): kommune
   * definition (da): den kommune matrikelnummeret hører til og som er blevet brugt til at stedfæste sagen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  kommune?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * sequenceNumber: 12
   * oracleName: matrikelmyndighedensJournalnum
   * dbName: matrikelmyndighedensJournalnum
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagmatrikelmyndighedensjournalnummer
   * prefLabel (da): matrikelmyndighedensJournalnummer
   * definition (da): det unikke sagsnummer som er tildelt af matrikelmyndigheden.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  matrikelmyndighedensJournalnum?: Maybe<Scalars['String']['output']>;
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * sequenceNumber: 13
   * dbName: registreringFra
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: registreringTil
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 14
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagregistreringsaktoer
   * prefLabel (da): registreringsaktør
   */
  registreringsaktoer: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * dbName: rekvirentRef
   * sequenceNumber: 16
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagrekvirentfef
   * prefLabel (da): rekvirentRef
   * definition (da): den sagsansvarliges (ofte landinspektørens) eget journalnummer for sagen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  rekvirentRef?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * dbName: sagstitel
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagsagstitel
   * prefLabel (da): sagstitel
   * definition (da): den repræsentative tekst, der beskriver sagen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sagstitel?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Sagsstatus
   * multiplicity: 1
   * dbName: status
   * size: 40
   * sequenceNumber: 18
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor sagen er i sin livscyklus
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * sequenceNumber: 19
   * dbName: virkningFra
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 21
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * transliteratedName: virkningsaktoer
   * sequenceNumber: 20
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaersagvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forvaltningsobjektets virkning
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_MatrikulaerSagConnection = {
  __typename?: 'MAT_MatrikulaerSagConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_MatrikulaerSagEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_MatrikulaerSag>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_MatrikulaerSagEdge = {
  __typename?: 'MAT_MatrikulaerSagEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_MatrikulaerSag;
};

export type Mat_MatrikulaerSagFilterInput = {
  and?: InputMaybe<Array<Mat_MatrikulaerSagFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  ejerlavLokalId?: InputMaybe<DafStringOperationFilterInput>;
  forretningsproces?: InputMaybe<DafStringOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  jordstykkeLokalId?: InputMaybe<DafStringOperationFilterInput>;
  journaliseringsdato?: InputMaybe<DafLocalDateOperationFilterInput>;
  kommune?: InputMaybe<DafStringOperationFilterInput>;
  matrikelmyndighedensJournalnum?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  rekvirentRef?: InputMaybe<DafStringOperationFilterInput>;
  sagstitel?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningsaktoer?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: SagsoperationType
 * dbName: SagsoperationType
 * definition (da): <memo>#NOTES#type med kode og betegnelse for en sagsoperation
 * historikmodel: bitemporalitet
 * prefLabel (da): Sagsoperation type
 * URI: https://data.gov.dk/model/profile/mu/sagsoperationtype
 * EAID: EAID_EBF89E48_CBB8_4049_8A52_E55AE94D178B
 */
export type Mat_MatrikulaerSag_Sagsoperation = {
  __typename?: 'MAT_MatrikulaerSag_sagsoperation';
  MatrikulaerSagobjectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/sagsoperationtypebetegnelse
   * prefLabel (da): betegnelse
   * definition (da): betegnelse for sagsoperationen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: betegnelse
   */
  betegnelse: Scalars['String']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/sagsoperationtypekode
   * prefLabel (da): kode
   * definition (da): kode for sagsoperationen
   * dbName: kode
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  kode: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
};

/** A connection to a list of items. */
export type Mat_MatrikulaerSag_SagsoperationConnection = {
  __typename?: 'MAT_MatrikulaerSag_sagsoperationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_MatrikulaerSag_SagsoperationEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_MatrikulaerSag_Sagsoperation>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_MatrikulaerSag_SagsoperationEdge = {
  __typename?: 'MAT_MatrikulaerSag_sagsoperationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_MatrikulaerSag_Sagsoperation;
};

export type Mat_MatrikulaerSag_SagsoperationFilterInput = {
  MatrikulaerSagobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_MatrikulaerSag_SagsoperationFilterInput>>;
  betegnelse?: InputMaybe<DafStringOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  kode?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Nullinje
 * comment (da): <memo>#NOTES#grænsen er fastlagt af den i henhold til § 4 i lov nr. 143 af 17. juni 1929 nedsatte kommission
 * dbName: Nullinje
 * definition (da): <memo>#NOTES#nullinjen i Nissum Fjord angiver grænsen for henholdsvis statens og strandejernes ejendomsret
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Nullinje
 * URI: https://data.gov.dk/model/profile/mu/nullinje
 * EAID: EAID_02530814_DE45_45ce_B12D_0AF41DC1663B
 */
export type Mat_Nullinje = {
  __typename?: 'MAT_Nullinje';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Curve
   * multiplicity: 1
   * dbName: geometri
   * sequenceNumber: 51
   * URI: https://data.gov.dk/model/profile/mu/nullinjegeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialLineStringEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_NullinjeConnection = {
  __typename?: 'MAT_NullinjeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_NullinjeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Nullinje>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_NullinjeEdge = {
  __typename?: 'MAT_NullinjeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Nullinje;
};

export type Mat_NullinjeFilterInput = {
  and?: InputMaybe<Array<Mat_NullinjeFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Nullinje_SekundaerForretningsh = {
  __typename?: 'MAT_Nullinje_sekundaerForretningsh';
  Nullinjeobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Nullinje_SekundaerForretningshConnection = {
  __typename?: 'MAT_Nullinje_sekundaerForretningshConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Nullinje_SekundaerForretningshEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Nullinje_SekundaerForretningsh>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Nullinje_SekundaerForretningshEdge = {
  __typename?: 'MAT_Nullinje_sekundaerForretningshEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Nullinje_SekundaerForretningsh;
};

export type Mat_Nullinje_SekundaerForretningshFilterInput = {
  Nullinjeobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Nullinje_SekundaerForretningshFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: OptagetVej
 * dbName: OptagetVej
 * definition (da): <memo>#NOTES#registrering af vej og sti, som tjener som adgang til anden ejendom, og som ikke er udskilt med eget vejlitra eller matrikelnummer
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Optaget vej
 * URI: https://data.gov.dk/model/profile/mu/optagetVej
 * EAID: EAID_6548492B_C1ED_4195_9E26_08FF64EB9CE4
 */
export type Mat_OptagetVej = {
  __typename?: 'MAT_OptagetVej';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Curve
   * multiplicity: 1
   * sequenceNumber: 51
   * dbName: geometri
   * URI: https://data.gov.dk/model/profile/mu/optagetvejgeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialLineStringEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Produktionsmetode
   * multiplicity: 1
   * size: 78
   * sequenceNumber: 52
   * dbName: produktionsmetode
   * URI: https://data.gov.dk/model/profile/mu/optagetvejproduktionsmetode
   * prefLabel (da): produktionsmetode
   * definition (da): angivelse af hvilken metode og baggrundsmateriale, som vejen er produceret ved hjælp af
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  produktionsmetode: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 0..1
   * sequenceNumber: 55
   * dbName: transformationsId
   * URI: https://data.gov.dk/model/profile/mu/optagetvejtransformationsid
   * prefLabel (da): transformationsId
   * definition (da): transformationsID er en fortløbende nummerering af transformationerne inden for det enkelte ejerlav
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  transformationsId?: Maybe<Scalars['Long']['output']>;
  /**
   * Grunddatamodel info:
   * type: Real
   * multiplicity: 0..1
   * sequenceNumber: 53
   * dbName: vejbredde
   * URI: https://data.gov.dk/model/profile/mu/optagetvejvejbredde
   * prefLabel (da): vejbredde
   * definition (da): vejens bredde
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  vejbredde?: Maybe<Scalars['Float']['output']>;
  /**
   * Grunddatamodel info:
   * type: Vejtype
   * multiplicity: 0..1
   * size: 8
   * sequenceNumber: 54
   * dbName: vejtype
   * URI: https://data.gov.dk/model/profile/mu/optagetvejvejtype
   * prefLabel (da): vejtype
   * definition (da): angiver typen af vej ud fra dens oprindelse
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  vejtype?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_OptagetVejConnection = {
  __typename?: 'MAT_OptagetVejConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_OptagetVejEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_OptagetVej>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_OptagetVejEdge = {
  __typename?: 'MAT_OptagetVejEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_OptagetVej;
};

export type Mat_OptagetVejFilterInput = {
  and?: InputMaybe<Array<Mat_OptagetVejFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_OptagetVej_SekundaerForretning = {
  __typename?: 'MAT_OptagetVej_sekundaerForretning';
  OptagetVejobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_OptagetVej_SekundaerForretningConnection = {
  __typename?: 'MAT_OptagetVej_sekundaerForretningConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_OptagetVej_SekundaerForretningEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_OptagetVej_SekundaerForretning>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_OptagetVej_SekundaerForretningEdge = {
  __typename?: 'MAT_OptagetVej_sekundaerForretningEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_OptagetVej_SekundaerForretning;
};

export type Mat_OptagetVej_SekundaerForretningFilterInput = {
  OptagetVejobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_OptagetVej_SekundaerForretningFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

export type Mat_Samletfastejendom_X_Jordstykke = {
  __typename?: 'MAT_SAMLETFASTEJENDOM_X_JORDSTYKKE';
  Jordstykkeobjectid: Scalars['Long']['output'];
  SamletFastEjendomobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
};

/** A connection to a list of items. */
export type Mat_Samletfastejendom_X_JordstykkeConnection = {
  __typename?: 'MAT_SAMLETFASTEJENDOM_X_JORDSTYKKEConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Samletfastejendom_X_JordstykkeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Samletfastejendom_X_Jordstykke>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Samletfastejendom_X_JordstykkeEdge = {
  __typename?: 'MAT_SAMLETFASTEJENDOM_X_JORDSTYKKEEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Samletfastejendom_X_Jordstykke;
};

export type Mat_Samletfastejendom_X_JordstykkeFilterInput = {
  Jordstykkeobjectid?: InputMaybe<DafLongOperationFilterInput>;
  SamletFastEjendomobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Samletfastejendom_X_JordstykkeFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: SamletFastEjendom
 * comment (da): <memo>#NOTES#begrebet er knyttet til arealer på jordoverfladen og er fysisk bestemt ved det eller de jordstykker, der indgår i den samlede faste ejendom (se definition af Jordstykke).Parcelhusgrunde vil normalt kun bestå af ét Jordstykke, hvorimod landbrugsejendomme ofte består af flere Jordstykker
 * dbName: SamletFastEjendom
 * definition (da): <memo>#NOTES#en vedvarende forening af et eller flere jordstykker som tilsammen udgør én ejendom
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Samlet fast ejendom
 * URI: https://data.gov.dk/model/profile/mu/samletfastejendom
 * EAID: EAID_9C1A6CF4_25D6_4e28_949F_D45BA79F9EF1
 */
export type Mat_SamletFastEjendom = {
  __typename?: 'MAT_SamletFastEjendom';
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/bestemtfastejendombfenummer
   * prefLabel (da): BFEnummer
   * definition (da): unikt fortløbende identifikation tildelt den specifikke bestemte fast ejendom
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * dbName: BFEnummer
   * sequenceNumber: 40
   */
  BFEnummer: Scalars['Long']['output'];
  StedbestemmelsesReference?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 0..1
   * URI: https://data.gov.dk/model/profile/mu/samletfastejendomarbejderbolig
   * prefLabel (da): arbejderbolig
   * definition (da): angiver om den samlede faste ejendom er en arbejderbolig
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * sequenceNumber: 51
   * dbName: arbejderbolig
   * size: 5
   */
  arbejderbolig?: Maybe<Scalars['Boolean']['output']>;
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/samletfastejendomerfaelleslod
   * prefLabel (da): erFælleslod
   * definition (da): angiver, at typen af samlet fast ejendom er fælleslod
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * sequenceNumber: 52
   * dbName: erFaelleslod
   * transliteratedName: erFaelleslod
   * size: 5
   */
  erFaelleslod: Scalars['Boolean']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_MultiSurface
   * multiplicity: 1
   * sequenceNumber: 53
   * dbName: geometri
   * URI: https://data.gov.dk/model/profile/mu/samletfastejendomgeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialMultiPolygonEpsg25832Type;
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * oracleName: hovedejendomOpdeltIEjerlejligh
   * size: 5
   * sequenceNumber: 54
   * dbName: hovedejendomOpdeltIEjerlejligh
   * URI: https://data.gov.dk/model/profile/mu/samletfastejendomhovedejendomopdeltiejerlejligheder
   * prefLabel (da): hovedejendom opdelt i ejerlejligheder
   * definition (da): angiver, om den pågældende samlede faste ejendom er registreret som hovedejendom og opdelt i ejerlejligheder
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  hovedejendomOpdeltIEjerlejligh: Scalars['Boolean']['output'];
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Landbrugsnotering
   * multiplicity: 0..1
   * dbName: landbrugsnotering
   * size: 21
   * sequenceNumber: 55
   * URI: https://data.gov.dk/model/profile/mu/samletfastejendomlandbrugsnotering
   * prefLabel (da): landbrugsnotering
   * definition (da): angiver hvorvidt ejendommen er noteret som landbrugsejendom og derfor har landbrugspligt
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  landbrugsnotering?: Maybe<Scalars['String']['output']>;
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Boolean
   * multiplicity: 1
   * sequenceNumber: 56
   * dbName: udskiltVej
   * size: 5
   * URI: https://data.gov.dk/model/profile/mu/samletfastejendomudskiltvej
   * prefLabel (da): udskilt vej
   * definition (da): angiver, om der er tale om en udskilt, offentlig vej med selvstændigt matrikelnummer
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  udskiltVej: Scalars['Boolean']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_SamletFastEjendomConnection = {
  __typename?: 'MAT_SamletFastEjendomConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_SamletFastEjendomEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_SamletFastEjendom>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_SamletFastEjendomEdge = {
  __typename?: 'MAT_SamletFastEjendomEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_SamletFastEjendom;
};

export type Mat_SamletFastEjendomFilterInput = {
  BFEnummer?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_SamletFastEjendomFilterInput>>;
  arbejderbolig?: InputMaybe<DafBooleanOperationFilterInput>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  erFaelleslod?: InputMaybe<DafBooleanOperationFilterInput>;
  forretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  hovedejendomOpdeltIEjerlejligh?: InputMaybe<DafBooleanOperationFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  landbrugsnotering?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  udskiltVej?: InputMaybe<DafBooleanOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_SamletFastEjendom_SekundaerFor = {
  __typename?: 'MAT_SamletFastEjendom_sekundaerFor';
  SamletFastEjendomobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_SamletFastEjendom_SekundaerForConnection = {
  __typename?: 'MAT_SamletFastEjendom_sekundaerForConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_SamletFastEjendom_SekundaerForEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_SamletFastEjendom_SekundaerFor>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_SamletFastEjendom_SekundaerForEdge = {
  __typename?: 'MAT_SamletFastEjendom_sekundaerForEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_SamletFastEjendom_SekundaerFor;
};

export type Mat_SamletFastEjendom_SekundaerForFilterInput = {
  SamletFastEjendomobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_SamletFastEjendom_SekundaerForFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Skelpunkt
 * dbName: Skelpunkt
 * definition (da): <memo>#NOTES#et punkt, der angiver et matrikelskels start eller slut
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Skelpunkt
 * URI: https://data.gov.dk/model/profile/mu/skelpunkt
 * EAID: EAID_CB7FE8B2_2081_4710_9348_B2241DCB4A96
 */
export type Mat_Skelpunkt = {
  __typename?: 'MAT_Skelpunkt';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Point
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/skelpunktgeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * sequenceNumber: 51
   * dbName: geometri
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialPointEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Indlægningstype
   * multiplicity: 1
   * URI: https://data.gov.dk/model/profile/mu/skelpunktindlaegningstype
   * prefLabel (da): indlægningstype
   * definition (da): angiver den måde hvorpå det pågældende skelpunkt er indlagt i matrikelkortet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * size: 49
   * dbName: indlaegningstype
   * transliteratedName: indlaegningstype
   * sequenceNumber: 52
   */
  indlaegningstype: Scalars['String']['output'];
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * dbName: oprindelseJournalnummer
   * sequenceNumber: 53
   * URI: https://data.gov.dk/model/profile/mu/skelpunktoprindelsejournalnummer
   * prefLabel (da): oprindelse journalnummer
   * definition (da): identifikation af den sag, via journalnummer, som indeholder de måloplysninger der er brugt til at angive objektets placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  oprindelseJournalnummer?: Maybe<Scalars['String']['output']>;
  oprindelsessagsLokalId?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Produktionsmetode
   * multiplicity: 1
   * size: 78
   * dbName: produktionsmetode
   * sequenceNumber: 54
   * URI: https://data.gov.dk/model/profile/mu/skelpunktproduktionsmetode
   * prefLabel (da): produktionsmetode
   * definition (da): angivelse af hvilken metode og baggrundsmateriale, som skelpunktet er produceret ved hjælp af
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  produktionsmetode: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: PunktKlasse
   * multiplicity: 1
   * size: 42
   * dbName: punktKlasse
   * sequenceNumber: 55
   * URI: https://data.gov.dk/model/profile/mu/skelpunktpunktklasse
   * prefLabel (da): punktKlasse
   * definition (da): klassificering af punktet i forhold til målemetode mv
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  punktKlasse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  supplerendeMaalingSagsLokalId?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Integer
   * multiplicity: 0..1
   * sequenceNumber: 56
   * dbName: transformationsId
   * URI: https://data.gov.dk/model/profile/mu/skelpunkttransformationsid
   * prefLabel (da): transformationsId
   * definition (da): transformationsID er en fortløbende nummerering af transformationerne inden for det enkelte ejerlav
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  transformationsId?: Maybe<Scalars['Long']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_SkelpunktConnection = {
  __typename?: 'MAT_SkelpunktConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_SkelpunktEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Skelpunkt>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_SkelpunktEdge = {
  __typename?: 'MAT_SkelpunktEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Skelpunkt;
};

export type Mat_SkelpunktFilterInput = {
  and?: InputMaybe<Array<Mat_SkelpunktFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  oprindelseJournalnummer?: InputMaybe<DafStringOperationFilterInput>;
  oprindelsessagsLokalId?: InputMaybe<DafStringOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  registreringFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  registreringTil?: InputMaybe<DafDateTimeOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  supplerendeMaalingSagsLokalId?: InputMaybe<DafStringOperationFilterInput>;
  virkningFra?: InputMaybe<DafDateTimeOperationFilterInput>;
  virkningTil?: InputMaybe<DafDateTimeOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Skelpunkt_SekundaerForretnings = {
  __typename?: 'MAT_Skelpunkt_sekundaerForretnings';
  Skelpunktobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Skelpunkt_SekundaerForretningsConnection = {
  __typename?: 'MAT_Skelpunkt_sekundaerForretningsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Skelpunkt_SekundaerForretningsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Skelpunkt_SekundaerForretnings>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Skelpunkt_SekundaerForretningsEdge = {
  __typename?: 'MAT_Skelpunkt_sekundaerForretningsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Skelpunkt_SekundaerForretnings;
};

export type Mat_Skelpunkt_SekundaerForretningsFilterInput = {
  Skelpunktobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Skelpunkt_SekundaerForretningsFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * name: Temalinje
 * comment (da): <memo>#NOTES#en temalinje kan skære flere jordstykker
 * dbName: Temalinje
 * definition (da): <memo>#NOTES#linje til registrering af afgrænsning for strandbeskyttelse, klitfredning, fredskov
 * historikmodel: bitemporalitet#NOTES#Values: registreringshistorik,bitemporalitet
 * prefLabel (da): Temalinje
 * URI: https://data.gov.dk/model/profile/mu/temalinje
 * EAID: EAID_4C640774_E725_4355_888E_968B26F7AC6A
 */
export type Mat_Temalinje = {
  __typename?: 'MAT_Temalinje';
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  feltliste?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: Forløb
   * multiplicity: 1
   * size: 27
   * dbName: forloeb
   * transliteratedName: forloeb
   * sequenceNumber: 51
   * URI: https://data.gov.dk/model/profile/mu/temalinjeforloeb
   * prefLabel (da): forløb
   * definition (da): hvordan linjerne skal håndteres i forbindelse med ændringer i det aktuelle skelbillede
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forloeb: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 1
   * dbName: forretningshaendelse
   * size: 76
   * transliteratedName: forretningshaendelse
   * sequenceNumber: 5
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningshaendelse
   * prefLabel (da): forretningshændelse
   * definition (da): den primære begivenhed i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningshaendelse: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikelForretningsområde
   * multiplicity: 1
   * dbName: forretningsomraade
   * size: 8
   * transliteratedName: forretningsomraade
   * sequenceNumber: 7
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsomraade
   * prefLabel (da): forretningsområde
   * definition (da): den del af den offentlige forretning der håndterer hændelsen og derved udvirker ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsomraade: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Sagskategori
   * multiplicity: 1
   * dbName: forretningsproces
   * size: 42
   * sequenceNumber: 8
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementforretningsproces
   * prefLabel (da): forretningsproces
   * definition (da): den manuelle eller IT-understøttede proces hvori forretningsområdet håndterer hændelsen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  forretningsproces: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: GM_Curve
   * multiplicity: 1
   * sequenceNumber: 52
   * dbName: geometri
   * URI: https://data.gov.dk/model/profile/mu/temalinjegeometri
   * prefLabel (da): geometri
   * definition (da): objektets geografiske placering
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * CRS: EPSG:25832
   * Z-used: False
   */
  geometri: SpatialLineStringEpsg25832Type;
  id_lokalId: Scalars['String']['output'];
  id_namespace: Scalars['String']['output'];
  matrikelskelLokalId?: Maybe<Scalars['String']['output']>;
  objectid: Scalars['Long']['output'];
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 0..1
   * dbName: originalTemafladeID
   * sequenceNumber: 53
   * URI: https://data.gov.dk/model/profile/mu/temalinjeoriginaltemafladeid
   * prefLabel (da): original temafladeID
   * definition (da): reference til den originale temaflade i matrikelsystemet
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  originalTemafladeID?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: PåtænktHandling
   * multiplicity: 0..1
   * dbName: paataenktHandling
   * size: 12
   * transliteratedName: paataenktHandling
   * sequenceNumber: 10
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementpåtaenkthandling
   * prefLabel (da): påtænkt handling
   * definition (da): den påtænkte handling for objekter med status 'Foreløbig'
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  paataenktHandling?: Maybe<Scalars['String']['output']>;
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: registreringFra
   * sequenceNumber: 11
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringfra
   * prefLabel (da): registrering fra
   * definition (da): tidspunktet hvor registreringen af versionen af forretningsobjektet er foretaget
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * sequenceNumber: 13
   * dbName: registreringTil
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringtil
   * prefLabel (da): registrering til
   * definition (da): tidspunktet hvor versionen af et forretningsobjekt enten er blevet erstattet af en nyere version eller er logisk slettet.
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: registreringsaktoer
   * transliteratedName: registreringsaktoer
   * sequenceNumber: 12
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementregistreringsaktoer
   * prefLabel (da): registreringsaktør
   * definition (da): den aktør der har foretaget registreringen
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  registreringsaktoer: Scalars['String']['output'];
  senesteSagLokalId: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementStatus
   * multiplicity: 1
   * dbName: status
   * size: 15
   * sequenceNumber: 14
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementstatus
   * prefLabel (da): status
   * definition (da): angivelse af hvor et forretningsobjekt er i sin livscyklus
   */
  status: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: Tematype
   * multiplicity: 1
   * size: 17
   * dbName: tematype
   * sequenceNumber: 54
   * URI: https://data.gov.dk/model/profile/mu/temalinjetematype
   * prefLabel (da): tematype
   * definition (da): typen af temalinje der er registreret på det pågældende jordstykke
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  tematype: Scalars['String']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 1
   * dbName: virkningFra
   * sequenceNumber: 15
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningfra
   * prefLabel (da): virkning fra
   * definition (da): tidspunktet hvorfra forretningsobjektet har virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningFra: Scalars['DafDateTime']['output'];
  /**
   * Grunddatamodel info:
   * type: DateTime
   * multiplicity: 0..1
   * dbName: virkningTil
   * sequenceNumber: 17
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningtil
   * prefLabel (da): virkning til
   * definition (da): tidspunktet hvor forretningsobjektets virkning ophører
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningTil?: Maybe<Scalars['DafDateTime']['output']>;
  /**
   * Grunddatamodel info:
   * type: CharacterString
   * multiplicity: 1
   * dbName: virkningsaktoer
   * sequenceNumber: 16
   * transliteratedName: virkningsaktoer
   * size: 100
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementvirkningsaktoer
   * prefLabel (da): virkningsaktør
   * definition (da): den aktør der har afstedkommet forretningsobjektets virkning
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  virkningsaktoer: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_TemalinjeConnection = {
  __typename?: 'MAT_TemalinjeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_TemalinjeEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Temalinje>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_TemalinjeEdge = {
  __typename?: 'MAT_TemalinjeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Temalinje;
};

export type Mat_TemalinjeFilterInput = {
  and?: InputMaybe<Array<Mat_TemalinjeFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  geometri?: InputMaybe<SpatialFilterInput>;
  id_lokalId?: InputMaybe<DafStringOperationFilterInput>;
  matrikelskelLokalId?: InputMaybe<DafStringOperationFilterInput>;
  objectid?: InputMaybe<DafLongOperationFilterInput>;
  originalTemafladeID?: InputMaybe<DafStringOperationFilterInput>;
  paataenktHandling?: InputMaybe<DafStringOperationFilterInput>;
  senesteSagLokalId?: InputMaybe<DafStringOperationFilterInput>;
  status?: InputMaybe<DafStringOperationFilterInput>;
  tematype?: InputMaybe<DafStringOperationFilterInput>;
};

/**
 * Grunddatamodel info:
 * EAID: EAID_A0A706C1_027A_46ec_AC79_9138DA725DF5
 */
export type Mat_Temalinje_SekundaerForretnings = {
  __typename?: 'MAT_Temalinje_sekundaerForretnings';
  Temalinjeobjectid: Scalars['Long']['output'];
  datafordelerOpdateringstid?: Maybe<Scalars['DafDateTime']['output']>;
  datafordelerRegisterImportSequenceNumber: Scalars['Int']['output'];
  datafordelerRowId: Scalars['UUID']['output'];
  datafordelerRowVersion: Scalars['Int']['output'];
  /**
   * Grunddatamodel info:
   * type: MatrikulærtElementForretningshændelse
   * multiplicity: 0..*
   * size: 76
   * maxOccurs: 5
   * transliteratedName: sekundaerForretningshaendelse
   * dbName: sekundaerForretningshaendelse
   * sequenceNumber: 6
   * URI: https://data.gov.dk/model/profile/mu/matrikulaertelementsekundaerforretningshaendelse
   * prefLabel (da): sekundær forretningshændelse
   * definition (da): de begivenheder i virkeligheden som udløste ændringen i data
   * legalSource: https://www.retsinformation.dk/eli/lta/2018/769
   */
  sekundaerForretningshaendelse: Scalars['String']['output'];
};

/** A connection to a list of items. */
export type Mat_Temalinje_SekundaerForretningsConnection = {
  __typename?: 'MAT_Temalinje_sekundaerForretningsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Mat_Temalinje_SekundaerForretningsEdge>>;
  /** A flattened list of the nodes. */
  nodes?: Maybe<Array<Mat_Temalinje_SekundaerForretnings>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type Mat_Temalinje_SekundaerForretningsEdge = {
  __typename?: 'MAT_Temalinje_sekundaerForretningsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node: Mat_Temalinje_SekundaerForretnings;
};

export type Mat_Temalinje_SekundaerForretningsFilterInput = {
  Temalinjeobjectid?: InputMaybe<DafLongOperationFilterInput>;
  and?: InputMaybe<Array<Mat_Temalinje_SekundaerForretningsFilterInput>>;
  datafordelerOpdateringstid?: InputMaybe<DafDateTimeOperationFilterInput>;
  datafordelerRegisterImportSequenceNumber?: InputMaybe<DafIntOperationFilterInput>;
  datafordelerRowId?: InputMaybe<DafUuidOperationFilterInput>;
  datafordelerRowVersion?: InputMaybe<DafIntOperationFilterInput>;
  sekundaerForretningshaendelse?: InputMaybe<DafStringOperationFilterInput>;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** Indicates whether more edges exist following the set defined by the clients arguments. */
  hasNextPage: Scalars['Boolean']['output'];
  /** Indicates whether more edges exist prior the set defined by the clients arguments. */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Query type for MAT - Matriklen2 */
export type Query = {
  __typename?: 'Query';
  DAF_RegisterImportStatus?: Maybe<Daf_RegisterImportStatus>;
  MAT_BygningPaaFremmedGrundFlade?: Maybe<Mat_BygningPaaFremmedGrundFladeConnection>;
  MAT_BygningPaaFremmedGrundFlade_se?: Maybe<Mat_BygningPaaFremmedGrundFlade_SeConnection>;
  MAT_BygningPaaFremmedGrundPunkt?: Maybe<Mat_BygningPaaFremmedGrundPunktConnection>;
  MAT_BygningPaaFremmedGrundPunkt_se?: Maybe<Mat_BygningPaaFremmedGrundPunkt_SeConnection>;
  MAT_Centroide?: Maybe<Mat_CentroideConnection>;
  MAT_Centroide_sekundaerForretnings?: Maybe<Mat_Centroide_SekundaerForretningsConnection>;
  MAT_Ejerlav?: Maybe<Mat_EjerlavConnection>;
  MAT_Ejerlejlighed?: Maybe<Mat_EjerlejlighedConnection>;
  MAT_Ejerlejlighed_sekundaerForretn?: Maybe<Mat_Ejerlejlighed_SekundaerForretnConnection>;
  MAT_Ejerlejlighedslod?: Maybe<Mat_EjerlejlighedslodConnection>;
  MAT_Ejerlejlighedslod_sekundaerFor?: Maybe<Mat_Ejerlejlighedslod_SekundaerForConnection>;
  MAT_Events?: Maybe<Mat_EventsConnection>;
  MAT_Jordstykke?: Maybe<Mat_JordstykkeConnection>;
  MAT_JordstykkeTemaflade?: Maybe<Mat_JordstykkeTemafladeConnection>;
  MAT_JordstykkeTemaflade_sekundaerF?: Maybe<Mat_JordstykkeTemaflade_SekundaerFConnection>;
  MAT_Jordstykke_sekundaerForretning?: Maybe<Mat_Jordstykke_SekundaerForretningConnection>;
  MAT_Jordstykke_stormfald?: Maybe<Mat_Jordstykke_StormfaldConnection>;
  MAT_Lodflade?: Maybe<Mat_LodfladeConnection>;
  MAT_Lodflade_sekundaerForretningsh?: Maybe<Mat_Lodflade_SekundaerForretningshConnection>;
  MAT_MatrikelKommune?: Maybe<Mat_MatrikelKommuneConnection>;
  MAT_MatrikelRegion?: Maybe<Mat_MatrikelRegionConnection>;
  MAT_MatrikelSogn?: Maybe<Mat_MatrikelSognConnection>;
  MAT_Matrikelskel?: Maybe<Mat_MatrikelskelConnection>;
  MAT_Matrikelskel_sekundaerForretni?: Maybe<Mat_Matrikelskel_SekundaerForretniConnection>;
  MAT_MatrikulaerSag?: Maybe<Mat_MatrikulaerSagConnection>;
  MAT_MatrikulaerSag_sagsoperation?: Maybe<Mat_MatrikulaerSag_SagsoperationConnection>;
  MAT_Nullinje?: Maybe<Mat_NullinjeConnection>;
  MAT_Nullinje_sekundaerForretningsh?: Maybe<Mat_Nullinje_SekundaerForretningshConnection>;
  MAT_OptagetVej?: Maybe<Mat_OptagetVejConnection>;
  MAT_OptagetVej_sekundaerForretning?: Maybe<Mat_OptagetVej_SekundaerForretningConnection>;
  MAT_SAMLETFASTEJENDOM_X_JORDSTYKKE?: Maybe<Mat_Samletfastejendom_X_JordstykkeConnection>;
  MAT_SamletFastEjendom?: Maybe<Mat_SamletFastEjendomConnection>;
  MAT_SamletFastEjendom_sekundaerFor?: Maybe<Mat_SamletFastEjendom_SekundaerForConnection>;
  MAT_Skelpunkt?: Maybe<Mat_SkelpunktConnection>;
  MAT_Skelpunkt_sekundaerForretnings?: Maybe<Mat_Skelpunkt_SekundaerForretningsConnection>;
  MAT_Temalinje?: Maybe<Mat_TemalinjeConnection>;
  MAT_Temalinje_sekundaerForretnings?: Maybe<Mat_Temalinje_SekundaerForretningsConnection>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_BygningPaaFremmedGrundFladeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_BygningPaaFremmedGrundFladeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_BygningPaaFremmedGrundFlade_SeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_BygningPaaFremmedGrundFlade_SeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_BygningPaaFremmedGrundPunktArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_BygningPaaFremmedGrundPunktFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_BygningPaaFremmedGrundPunkt_SeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_BygningPaaFremmedGrundPunkt_SeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_CentroideArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_CentroideFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Centroide_SekundaerForretningsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Centroide_SekundaerForretningsFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_EjerlavArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_EjerlavFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_EjerlejlighedArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_EjerlejlighedFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Ejerlejlighed_SekundaerForretnArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Ejerlejlighed_SekundaerForretnFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_EjerlejlighedslodArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_EjerlejlighedslodFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Ejerlejlighedslod_SekundaerForArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Ejerlejlighedslod_SekundaerForFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_EventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_EventsFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_JordstykkeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_JordstykkeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_JordstykkeTemafladeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_JordstykkeTemafladeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_JordstykkeTemaflade_SekundaerFArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_JordstykkeTemaflade_SekundaerFFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Jordstykke_SekundaerForretningArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Jordstykke_SekundaerForretningFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Jordstykke_StormfaldArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Jordstykke_StormfaldFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_LodfladeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_LodfladeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Lodflade_SekundaerForretningshArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Lodflade_SekundaerForretningshFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_MatrikelKommuneArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_MatrikelKommuneFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_MatrikelRegionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_MatrikelRegionFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_MatrikelSognArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_MatrikelSognFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_MatrikelskelArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_MatrikelskelFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Matrikelskel_SekundaerForretniArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Matrikelskel_SekundaerForretniFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_MatrikulaerSagArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_MatrikulaerSagFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_MatrikulaerSag_SagsoperationArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_MatrikulaerSag_SagsoperationFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_NullinjeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_NullinjeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Nullinje_SekundaerForretningshArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Nullinje_SekundaerForretningshFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_OptagetVejArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_OptagetVejFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_OptagetVej_SekundaerForretningArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_OptagetVej_SekundaerForretningFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Samletfastejendom_X_JordstykkeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Samletfastejendom_X_JordstykkeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_SamletFastEjendomArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_SamletFastEjendomFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_SamletFastEjendom_SekundaerForArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_SamletFastEjendom_SekundaerForFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_SkelpunktArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_SkelpunktFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Skelpunkt_SekundaerForretningsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Skelpunkt_SekundaerForretningsFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_TemalinjeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
  where?: InputMaybe<Mat_TemalinjeFilterInput>;
};

/** Query type for MAT - Matriklen2 */
export type QueryMat_Temalinje_SekundaerForretningsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Mat_Temalinje_SekundaerForretningsFilterInput>;
};

/** Filter type for the spatial method ST_Contains. Is applied as ST_Contains(A, B) where A is the register data field and B is the input value. */
export type SpatialContainsOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Filter type for the spatial method ST_CoveredBy. Is applied as ST_CoveredBy(A, B) where A is the register data field and B is the input value. */
export type SpatialCoveredByOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Filter type for the spatial method ST_Covers. Is applied as ST_Covers(A, B) where A is the register data field and B is the input value. */
export type SpatialCoversOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Filter type for the spatial method ST_Crosses. Is applied as ST_Crosses(A, B) where A is the register data field and B is the input value. */
export type SpatialCrossesOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

export enum SpatialDimensionEnumType {
  Xy = 'XY',
  Xyz = 'XYZ',
}

export type SpatialFilterInput = {
  and?: InputMaybe<Array<SpatialFilterInput>>;
  contains?: InputMaybe<SpatialContainsOperationFilterInput>;
  coveredBy?: InputMaybe<SpatialCoveredByOperationFilterInput>;
  covers?: InputMaybe<SpatialCoversOperationFilterInput>;
  crosses?: InputMaybe<SpatialCrossesOperationFilterInput>;
  intersects?: InputMaybe<SpatialIntersectsOperationFilterInput>;
  or?: InputMaybe<Array<SpatialFilterInput>>;
  overlaps?: InputMaybe<SpatialOverlapsOperationFilterInput>;
  touches?: InputMaybe<SpatialTouchesOperationFilterInput>;
  within?: InputMaybe<SpatialWithinOperationFilterInput>;
};

export enum SpatialGeometryNameEnumType {
  LineString = 'LineString',
  MultiLineString = 'MultiLineString',
  MultiPoint = 'MultiPoint',
  MultiPolygon = 'MultiPolygon',
  Point = 'Point',
  Polygon = 'Polygon',
}

export type SpatialInterfaceType = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['output'];
  /** The dimensions used by the geometry. */
  dimension: SpatialDimensionEnumType;
  /** The OGC geometry type of the geometry. */
  type: SpatialGeometryNameEnumType;
  /** The WKT representation of the geometry */
  wkt?: Maybe<Scalars['String']['output']>;
};

/** Filter type for the spatial method ST_Intersects. Is applied as ST_Intersects(A, B) where A is the register data field and B is the input value. */
export type SpatialIntersectsOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Spatial LineString type with XY-dimensions in the EPSG 25832 coordinate system. */
export type SpatialLineStringEpsg25832Type = SpatialInterfaceType & {
  __typename?: 'SpatialLineStringEpsg25832Type';
  crs: Scalars['Int']['output'];
  dimension: SpatialDimensionEnumType;
  type: SpatialGeometryNameEnumType;
  wkt: Scalars['String']['output'];
};

/** Spatial MultiPolygon type with XY-dimensions in the EPSG 25832 coordinate system. */
export type SpatialMultiPolygonEpsg25832Type = SpatialInterfaceType & {
  __typename?: 'SpatialMultiPolygonEpsg25832Type';
  crs: Scalars['Int']['output'];
  dimension: SpatialDimensionEnumType;
  type: SpatialGeometryNameEnumType;
  wkt: Scalars['String']['output'];
};

/** Filter type for the spatial method ST_Overlaps. Is applied as ST_Overlaps(A, B) where A is the register data field and B is the input value. */
export type SpatialOverlapsOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Spatial Point type with XY-dimensions in the EPSG 25832 coordinate system. */
export type SpatialPointEpsg25832Type = SpatialInterfaceType & {
  __typename?: 'SpatialPointEpsg25832Type';
  crs: Scalars['Int']['output'];
  dimension: SpatialDimensionEnumType;
  type: SpatialGeometryNameEnumType;
  wkt: Scalars['String']['output'];
};

/** Spatial Polygon type with XY-dimensions in the EPSG 25832 coordinate system. */
export type SpatialPolygonEpsg25832Type = SpatialInterfaceType & {
  __typename?: 'SpatialPolygonEpsg25832Type';
  crs: Scalars['Int']['output'];
  dimension: SpatialDimensionEnumType;
  type: SpatialGeometryNameEnumType;
  wkt: Scalars['String']['output'];
};

/** Filter type for the spatial method ST_Touches. Is applied as ST_Touches(A, B) where A is the register data field and B is the input value. */
export type SpatialTouchesOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Filter type for the spatial method ST_Within. Is applied as ST_Within(A, B) where A is the register data field and B is the input value. */
export type SpatialWithinOperationFilterInput = {
  /** The coordinate reference system of the geometry. */
  crs: Scalars['Int']['input'];
  /** The WKT representation of the geometry */
  wkt: Scalars['String']['input'];
};

/** Subscription type for MAT - Matriklen2 */
export type Subscription = {
  __typename?: 'Subscription';
  DAF_RegisterImportStatus: Daf_RegisterImportStatus;
  MAT_Events: Mat_Events;
};

/** Subscription type for MAT - Matriklen2 */
export type SubscriptionMat_EventsArgs = {
  where?: InputMaybe<Mat_EventsFilterInput>;
};

export type MatJordstykkeByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid: Scalars['DafDateTime']['input'];
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
}>;

export type MatJordstykkeByIdQuery = {
  __typename?: 'Query';
  MAT_Jordstykke?: {
    __typename?: 'MAT_JordstykkeConnection';
    nodes?: Array<{
      __typename?: 'MAT_Jordstykke';
      id_lokalId: string;
      matrikelnummer?: string | null;
      ejerlavLokalId: string;
      registreretAreal: number;
    }> | null;
  } | null;
};

export type MatEjerlavByIdQueryVariables = Exact<{
  id: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid: Scalars['DafDateTime']['input'];
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
}>;

export type MatEjerlavByIdQuery = {
  __typename?: 'Query';
  MAT_Ejerlav?: {
    __typename?: 'MAT_EjerlavConnection';
    nodes?: Array<{
      __typename?: 'MAT_Ejerlav';
      id_lokalId: string;
      ejerlavskode: number;
      ejerlavsnavn: string;
    }> | null;
  } | null;
};

export type MatCentroideByPointQueryVariables = Exact<{
  wkt: Scalars['String']['input'];
  crs: Scalars['Int']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  registreringstid: Scalars['DafDateTime']['input'];
  virkningstid?: InputMaybe<Scalars['DafDateTime']['input']>;
}>;

export type MatCentroideByPointQuery = {
  __typename?: 'Query';
  MAT_Centroide?: {
    __typename?: 'MAT_CentroideConnection';
    nodes?: Array<{
      __typename?: 'MAT_Centroide';
      id_lokalId: string;
      jordstykkeLokalId: string;
    }> | null;
  } | null;
};

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<
    DocumentTypeDecoration<TResult, TVariables>['__apiType']
  >;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}

export const MatJordstykkeByIdDocument = new TypedDocumentString(`
    query MatJordstykkeById($id: String!, $first: Int = 1, $registreringstid: DafDateTime!, $virkningstid: DafDateTime) {
  MAT_Jordstykke(
    first: $first
    registreringstid: $registreringstid
    virkningstid: $virkningstid
    where: {id_lokalId: {eq: $id}}
  ) {
    nodes {
      id_lokalId
      matrikelnummer
      ejerlavLokalId
      registreretAreal
    }
  }
}
    `);
export const MatEjerlavByIdDocument = new TypedDocumentString(`
    query MatEjerlavById($id: String!, $first: Int = 1, $registreringstid: DafDateTime!, $virkningstid: DafDateTime) {
  MAT_Ejerlav(
    first: $first
    registreringstid: $registreringstid
    virkningstid: $virkningstid
    where: {id_lokalId: {eq: $id}}
  ) {
    nodes {
      id_lokalId
      ejerlavskode
      ejerlavsnavn
    }
  }
}
    `);
export const MatCentroideByPointDocument = new TypedDocumentString(`
    query MatCentroideByPoint($wkt: String!, $crs: Int!, $first: Int = 1, $registreringstid: DafDateTime!, $virkningstid: DafDateTime) {
  MAT_Centroide(
    first: $first
    registreringstid: $registreringstid
    virkningstid: $virkningstid
    where: {geometri: {intersects: {wkt: $wkt, crs: $crs}}}
  ) {
    nodes {
      id_lokalId
      jordstykkeLokalId
    }
  }
}
    `);

const injectedRtkApi = matGraphqlApiSlice.injectEndpoints({
  endpoints: (build) => ({
    MatJordstykkeById: build.query<
      MatJordstykkeByIdQuery,
      MatJordstykkeByIdQueryVariables
    >({
      query: (variables) => ({
        document: MatJordstykkeByIdDocument.toString(),
        variables,
      }),
      transformResponse: (response: MatJordstykkeByIdQuery) => response,
    }),
    MatEjerlavById: build.query<
      MatEjerlavByIdQuery,
      MatEjerlavByIdQueryVariables
    >({
      query: (variables) => ({
        document: MatEjerlavByIdDocument.toString(),
        variables,
      }),
      transformResponse: (response: MatEjerlavByIdQuery) => response,
    }),
    MatCentroideByPoint: build.query<
      MatCentroideByPointQuery,
      MatCentroideByPointQueryVariables
    >({
      query: (variables) => ({
        document: MatCentroideByPointDocument.toString(),
        variables,
      }),
      transformResponse: (response: MatCentroideByPointQuery) => response,
    }),
  }),
});

export { injectedRtkApi as api };
export const {
  useMatJordstykkeByIdQuery,
  useLazyMatJordstykkeByIdQuery,
  useMatEjerlavByIdQuery,
  useLazyMatEjerlavByIdQuery,
  useMatCentroideByPointQuery,
  useLazyMatCentroideByPointQuery,
} = injectedRtkApi;
